<template>
  <div class="home">
    <Nav />

    <div class="topbox" v-if="isShowTopbox && indexdata && bmdata && vcdata">
      <el-carousel :interval="5000" height="592px" arrow="always">
        <el-carousel-item
          v-for="item in $store.state.bannerlist"
          :key="item.id"
        >
          <img :src="item.banner_image" alt="" />
        </el-carousel-item>
      </el-carousel>

      <div class="bm_panel" v-if="isShowBm">
        <div class="bmtit">
          <div class="bmt1">课程报名</div>
          <div class="bmt2">COURSE ENROLMENT</div>
        </div>

        <el-form
          class="ruleForm"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm1"
        >
          <el-form-item class="it1" prop="name">
            <el-input
              v-model="ruleForm.name"
              prefix-icon="el-icon-user-solid"
              placeholder="输入姓名"
            ></el-input>
          </el-form-item>

          <el-form-item class="it2" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              prefix-icon="el-icon-phone"
              placeholder="输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item class="it3" prop="region">
            <i class="el-icon-s-order"></i>
            <el-select v-model="ruleForm.region" placeholder="请选择课程">
              <el-option
                v-for="sub in course_list"
                :key="sub.id"
                :label="sub.course_name"
                :value="sub.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="it4" prop="ma">
            <el-input v-model="ruleForm.ma" placeholder="输入验证码"></el-input>
            <img :src="vcdata.img" alt="" @click="fetch_vc" />
          </el-form-item>

          <el-form-item class="it5">
            <el-button
              class="submit_btn"
              type="primary"
              @click="submitForm('ruleForm1')"
              >报名课程</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <router-view></router-view>

    <div class="fc">
      <div class="ma">
        <div class="ma_panel"></div>
        <img :src="contactInfo.contact_wechat_qrcode" alt="" />
      </div>
      <div class="dh">
        <div class="dh_panel"></div>
        <div class="dh_num">咨询电话：{{ contactInfo.contact_phone_num }}</div>
      </div>

      <div class="bm" @click="onBackIndex"></div>

      <div class="db" @click="onBackTop"></div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/nav/nav.vue";
import Footer from "@/components/footer/footer.vue";

export default {
  name: "Home",
  components: {
    Nav,
    Footer,
  },
  data: function () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      }

      let regex = new RegExp("^[\u4e00-\u9fa5]+$");
      let res = regex.test(value);
      if (!res) {
        return callback(new Error("请输入正确的姓名"));
      }

      callback();
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }

      let regex = new RegExp("^[1][3,4,5,7,8,9][0-9]{9}$");
      let res = regex.test(value);
      if (!res) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    var checkRegion = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择课程"));
      }
      callback();
    };
    var checkMa = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      }

      callback();
    };

    return {
      indexdata: null,
      bmdata: null,
      vcdata: null,
      course_list: [],
      isShowTopbox: false,
      isShowBm: false,

      ruleForm: {
        name: "",
        phone: "",
        region: "",
        ma: "",
      },

      rules: {
        name: [{ validator: checkName }],
        phone: [{ validator: checkPhone }],
        region: [{ validator: checkRegion }],
        ma: [{ validator: checkMa }],
      },

      contactInfo: null,
    };
  },
  created() {
    console.log("Home created", this.$store);
    if (
      this.$route.name === "User" ||
      this.$route.name === "Look" ||
      this.$route.name === "ChangePwd" ||
      this.$route.name === "CheckFile"
    ) {
      this.isShowTopbox = false;
    } else {
      this.isShowTopbox = true;
    }
    if (this.$route.name === "Main") {
      this.isShowBm = true;
    } else {
      this.isShowBm = false;
    }

    this.fetch();
    this.fetch_contactInfo();
  },
  watch: {
    $route(to) {
      // console.log("route :",to,from);
      if (
        to.name === "User" ||
        to.name === "Look" ||
        this.$route.name === "ChangePwd" ||
        this.$route.name === "CheckFile"
      ) {
        this.isShowTopbox = false;
      } else {
        this.isShowTopbox = true;
      }

      if (to.name === "Main") {
        let pp=document.documentElement;
        let stop=document.body;
        pp.scrollTop = stop.scrollTop = 0;

        this.isShowBm = true;
      } else {
        this.isShowBm = false;
      }
    },
  },
  methods: {
    async fetch() {
      let data = await this.$fly.get("/index/index");
      this.indexdata = data;
      // console.log("indexdata:",this.indexdata);

      let bmdata = await this.$fly.get("/course/allCourseByCate");
      for (let i = 0; i < bmdata.length; i++) {
        this.course_list = this.course_list.concat(bmdata[i].course_list);
      }

      this.bmdata = bmdata;
      // console.log("bmdata:", this.bmdata, this.course_list);

      this.fetch_vc();
    },
    async fetch_vc() {
      let vcdata = await this.$fly.get("/user/verifyCode");
      this.vcdata = vcdata;
      // console.log("vcdata:", this.vcdata);
    },
    async fetch_contactInfo() {
      let data = await this.$fly.get("/common/contactInfo");
      this.contactInfo = data;
    },
    submitForm(formName) {
      let self = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let sendObj = {
            contact_name: this.ruleForm.name,
            contact_phone: this.ruleForm.phone,
            course_id: this.ruleForm.region,
            captcha: this.ruleForm.ma,
            key: this.vcdata.key,
          };

          this.$fly
            .post("/user/signUpCourse", this.$qs.stringify(sendObj))
            .then(function (response) {
              if (response === 200) {
                self.$alert(self.ruleForm.name + "你已成功报名！", "报名成功", {
                  confirmButtonText: "确定",
                  callback: () => {
                    console.log("成功！");
                    self.$refs[formName].resetFields();
                  },
                });
              } else {
                self.fetch_vc();
              }
            });
        } else {
          console.log("error submit!!");
          // return false;
        }
      });
    },
    onBackTop(){
      let pp=document.documentElement;
      let stop=document.body;
      let timer = setInterval(function(){
          //获取滚动条的滚动高度
          let osTop = pp.scrollTop || stop.scrollTop;
          //用于设置速度差，产生缓动的效果
          let speed = Math.floor(-osTop / 6);
          pp.scrollTop = stop.scrollTop = osTop + speed;
          //用于阻止滚动事件清除定时器
          // let isTop = true;  
          if(osTop == 0){
              clearInterval(timer);
          }
      },10);
   },
   onBackIndex(){
     if (this.$router.history.current.name === "Main"){
       this.onBackTop();
     }else{
       this.$router.push({ name: 'Main'});
     }
   }
  },
};
</script>

<style lang='scss'>
.home {
  .topbox {
    position: relative;
    overflow: hidden;

    .el-carousel__item {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 1924px;
        height: 592px;
      }
    }

    .el-carousel__button {
      width: 16px;
      height: 16px;
      border-radius: 8px;
    }

    .is-active button {
      background-color: #00b3a4;
    }

    .el-carousel__arrow {
      display: none;
    }

    .bm_panel {
      position: absolute;
      top: 110px;
      right: 20%;
      z-index: 9;
      width: 246px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
      padding: 20px;

      .bmtit {
        text-align: center;
        font-size: 20px;
        color: #00b3a4;

        .bmt2 {
          font-size: 10px;
          color: #999999;
          margin: 10px 0;
        }
      }

      .ruleForm {
        .it3 {
          .el-icon-s-order {
            position: absolute;
            position: absolute;
            z-index: 1;
            top: 12px;
            left: 10px;
            color: #c0c4cc;
          }

          .el-select {
            width: 100%;

            .el-input__inner {
              padding-left: 30px;
            }
          }
        }

        .it4 {
          .el-form-item__content {
            display: flex;
          }
          .el-input {
            width: 50%;
          }

          img {
            width: 103px;
            height: 40px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }

        .it5 {
          margin-bottom: 0;
        }

        .submit_btn {
          width: 100%;
        }
      }
    }
  }

  .fc {
    position: fixed;
    top: 40%;
    right: 5%;
    z-index: 99;

    .ma {
      width: 50px;
      height: 50px;
      background: url(../assets/ma1.png) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;

      .ma_panel {
        width: 156px;
        height: 142px;
        background: url(../assets/mapanel.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: -48px;
        left: -145px;
        display: none;
      }

      img {
        width: 100px;
        position: absolute;
        top: -30px;
        left: -122px;
        display: none;
      }
    }
    .ma:hover {
      background: url(../assets/ma2.png) no-repeat;
      background-size: 100% 100%;

      .ma_panel,
      img {
        display: block;
      }
    }

    .dh {
      width: 50px;
      height: 50px;
      background: url(../assets/dh.png) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      margin: 10px 0;

      .dh_panel {
        width: 268px;
        height: 62px;
        background: url(../assets/dhpanel.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 54px;
        left: -256px;
        display: none;
      }

      .dh_num {
        position: absolute;
        top: 75px;
        left: -212px;
        font-size: 16px;
        color: #494949;
        display: none;
      }
    }

    .dh:hover {
      .dh_panel,
      .dh_num {
        display: block;
      }
    }

    .db {
      width: 50px;
      height: 50px;
      background: url(../assets/db1.png) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .db:hover {
      background: url(../assets/db2.png) no-repeat;
      background-size: 100% 100%;
    }

    .bm {
      width: 50px;
      height: 50px;
      margin: 10px 0;
      background: url(../assets/bm1.png) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .bm:hover {
      background: url(../assets/bm2.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
